import { useEffect } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Row,
  Stack,
} from "react-bootstrap";
import { Link } from "react-router-dom";

const UpdatedAboutPage = () => {
  useEffect(() => {
    document.title = "Daly Exercise+ | About";
  }, []);

  const instagramLink = () => {
    let url = "https://www.instagram.com/dalyexercise/";
    window.open(url, "_blank").focus();
  };

  const tiktokLink = () => {
    let url = "https://www.tiktok.com/@dalyexercise";
    window.open(url, "_blank").focus();
  };
  return (
    <Container className="full-page-length text-center-mobile" fluid>
      <div className="about-section-1">
        <Row>
          <Col md={6} className="d-flex align-items-center about-1">
            <div>
              {/* <h1 className="about-title">Daly Exercise+</h1> */}
              <img
                alt=""
                src={"icons/logo_white.png"}
                // width="100"
                // height="50"
                className="landing-logo"
              />{" "}
              {/* <br />
              <h2 className=" h2">
                Add a <b className="headingColour">+</b> to your{" "}
                <b className="headingColour">P.E.</b>
              </h2> */}
              <br />
              <div className=" h3 text-white">
                <b className="orange-text">Daly Exercise+</b> makes teaching
                P.E. <b className="orange-text">stress free, easy to follow</b>{" "}
                and more importantly <b className="orange-text">fun</b> for you
                and your whole class!
              </div>
              <br />
              <Link to={`/register/teacher`} className="text-link">
                <div className="">
                  <Button
                    variant="primary"
                    className="de-navbar-button button-padding"
                  >
                    Start Your Free Trial
                  </Button>
                </div>
              </Link>
            </div>
          </Col>
          <Col
            md={6}
            className=" d-flex align-items-center justify-content-center"
          >
            <img
              src="/icons/icon_hero.png"
              className="about-section-image"
              alt="Plan Icon"
            ></img>
          </Col>
        </Row>
      </div>
      <div className="about-section-2">
        {/* <br />
        <h1 className="about-heading text-center"> Add a + to your P.E.</h1>
        <br /> */}
        {/* <div className="about-section-3"> */}
        <div className="video-responsive highlight-border">
          <iframe
            // width="853"
            // height="300"
            src={`https://player.vimeo.com/video/995325856?h=f867e8130d`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
          {/* </div> */}
        </div>
      </div>
      <div className="about-section-4">
        <Row>
          <Col
            md={6}
            className="align-items-center d-flex justify-content-center"
          >
            <div>
              <h1 className="about-heading ">Yearly and Fortnightly Plans</h1>
              <br />
              <div className="feature-text">
                <b>Structured lesson plans</b> that make teaching P.E.{" "}
                <b>simple, engaging, and accessible</b>. Our{" "}
                <b>yearly and fortnightly plans</b> provide a clear roadmap,
                ensuring <b>balanced skill development and variety</b> for all
                students.
              </div>
            </div>
          </Col>
          <Col
            md={6}
            className=" d-flex align-items-center justify-content-center"
          >
            <img
              src="/icons/icon_structured_plans.png"
              className="about-section-image"
              alt="Plan Icon"
            ></img>
          </Col>
        </Row>
      </div>

      <div className="about-section-5">
        <Row>
          <Col
            md={6}
            className=" d-flex align-items-center justify-content-center"
          >
            <img
              src="/icons/icon_videos.png"
              className="about-section-image"
              alt="Videos Icon"
            ></img>
          </Col>
          <Col
            md={6}
            className="align-items-center d-flex justify-content-center"
          >
            <div>
              <h1 className="about-heading ">Over 300 Videos and Exercises</h1>
              <br />
              <div className="feature-text">
                Access <b>over 300 high-quality videos and exercises</b> on any
                device—desktop, tablet, or mobile. Engage your students with
                lessons, skill demonstrations, and fun activities that make P.E.{" "}
                <b>exciting, accessible, and easy to teach</b>.
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="about-section-6">
        <Row>
          <Col
            md={6}
            className="align-items-center d-flex justify-content-center"
          >
            <div>
              <h1 className="about-heading ">In Class and At Home Workouts</h1>
              <br />
              <div className="feature-text">
                Take a break during class and keep your students active with our{" "}
                <b>classroom exercises</b>. Assign <b>at-home workouts</b> to
                encourage movement beyond the classroom. Easily{" "}
                <b>manage and create custom homework</b> to fit your students'
                needs.
              </div>
            </div>
          </Col>
          <Col
            md={6}
            className=" d-flex align-items-center justify-content-center"
          >
            <img
              src="/icons/icon_home_workouts.png"
              className="about-section-image"
              alt="Videos Icon"
            ></img>
          </Col>
        </Row>
      </div>

      <div className="about-section-7">
        {/* <br />
        <h1 className="about-heading text-center w-100"> Testimonials</h1>
        <br />
        <Row>
          <Col md={12}></Col>
          <Col
            md={6}
            className="align-items-center d-flex justify-content-center"
          ></Col>
          <Col
            md={6}
            className=" d-flex align-items-center justify-content-center"
          ></Col>
        </Row> */}
      </div>
    </Container>
  );
};

export default UpdatedAboutPage;
